// contexts/AIContext.tsx
"use client"

import { createContext, ReactNode, useContext, useState } from "react"

type AIContextType = {
  isSmallOpen: boolean
  toggle: (open: boolean) => void
  toggleClose: (open: boolean) => void
  isCloseHeader: boolean
}

const AIContext = createContext<AIContextType | undefined>(undefined)

export function AIProvider({ children }: { children: ReactNode }) {
  const [isSmallOpen, setIsSmallOpen] = useState(false)
  const [isCloseHeader, setIsCloseHeader] = useState(false)

  const toggle = (open: boolean) => setIsSmallOpen(open)
  const toggleClose = (open: boolean) => setIsCloseHeader(open)

  return (
    <AIContext.Provider
      value={{ isSmallOpen, toggle, isCloseHeader, toggleClose }}
    >
      {children}
    </AIContext.Provider>
  )
}

export function useAI() {
  const context = useContext(AIContext)
  if (!context) throw new Error("useAI must be used within AIProvider")
  return context
}
